/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import Button from '../common/Button';
import Input from '../common/Input';
import { selectSkillTypeSlide, setSelectedSkillType, toggleSkillTypeSlide } from '../../store/slices/common';
import SlideOver from '../SlideOver';
import { createSkillType, updateSkillType } from '../../store/slices/api/inner/skillTypeSlice';
import { fetchIndustries, setIndustriesData } from '../../store/slices/api/inner/industriesSlice';
import Select from '../common/Select';

const SkillTypeForm = ({
    defaultData,
    fetchData,
}) => {
    const SkillTypeIsOpen = useSelector(selectSkillTypeSlide);
    const dispatch = useDispatch();
    const [industryOptions, setIndustryOptions] = useState([])


    const defaultValues = {
        skillTypeId: defaultData?.skill_type_id ?? "",
        industryId: defaultData?.industry_id ?? "",
        skillTypeName: defaultData?.skill_type_name ?? "",
    }

    const afterAPICall = (response) => {
        fetchData()
        dispatch(toggleSkillTypeSlide())
        dispatch(setSelectedSkillType(null))
    }

    const beforeAPICall = (data) => {
        
        return {
            success: true,
            refactoredData: {
                skillTypeId: defaultData?.skill_type_id ?? "",
                industryId: data.industryId ?? "",
                skillTypeName: data.skillTypeName
            }
        }
    }
    
    const { isLoading, control, handleSubmit, setValue } = useApiRequest({
        apiAction: defaultData ? updateSkillType : createSkillType,
        defaultValues,
        clearForm: true,
        beforeAPICall,
        afterAPICall,
    });

    useEffect(() => {
        if (defaultData) {
            setValue('skillTypeId', defaultData.skill_type_id ?? "");
            setValue('industryId', defaultData.industry_id ?? "");
            setValue('skillTypeName', defaultData.skill_type_name ?? "");
        } else {
            setValue('skillTypeId', "");
            setValue('industryId', "");
            setValue('skillTypeName', "");
        }
    }, [defaultData, setValue]);

     // fetch start
     const afterFetch = (response) => {
        setIndustryOptions(response ? response?.map(industry => ({ label: industry?.industry_name, value: industry?.industry_id })) : [])
    }
    const { handleSubmit: fetchIndustriesData } = useApiRequest({
        apiAction: fetchIndustries,
        setValueAction: setIndustriesData,
        isForm: false,
        successMessage: false,
        afterAPICall: afterFetch,
      });

      useEffect(() => {
        fetchIndustriesData()
      }, [])
    
    

    return (
        <SlideOver isOpen={SkillTypeIsOpen} toggleOpen={toggleSkillTypeSlide} panelName={defaultData ?  "Update Skill Type" : "Add Skill Type" }>
            <form onSubmit={handleSubmit}>
                <Input
                    control={control}
                    name="skillTypeName"
                    rules={{
                        required: "this field is required"
                    }}
                    label="Name"
                />
                 <Select
                    control={control}
                    name="industryId"
                    rules={{ required: "this field is required" }}
                    options={industryOptions}
                />


                <div className="flex justify-end my-6">
                    <Button isLoading={isLoading}>
                        {defaultData ? "Save changes" : "Submit"}
                    </Button>
                </div>
            </form>
        </SlideOver>
    )
}

export default SkillTypeForm